import {createSlice} from "@reduxjs/toolkit";

const initialUsersState = {
  isLoading: false,
  data: [],
  notification: null
};

export const usersSlice = createSlice({
  name: "users",
  initialState: initialUsersState,
  reducers: {
    // User Responses
    userNotification: (state, action) => {
      state.isLoading = false;
      state.notification = action.payload.notification;
    },

    // User Loading
    isLoading: (state, action) => {
      state.isLoading = true;
    },

    // fetchUsers
    usersFetched: (state, action) => {
      state.isLoading = false;
      state.data = action.payload.data;
    },

    // addUser
    userCreated: (state, action) => {
      state.isLoading = false;
      state.notification = {type: "success", message: "User Account Created Successful"};
    },

    // updateUser
    userUpdated: (state, action) => {
      state.notification = {type: "success", message: "User Account Updated Successful"};
      state.data = state.data.map(user => {
        if (user.id === action.payload.data.id) {
          return action.payload.data;
        }
        return user;
      });
    },

    // deleteUser
    userDeleted: (state, action) => {
      state.notification = {type: "success", message: "User Account Deleted Successful"};
      state.data = state.data.filter(el => el.id !== action.payload.id);
    }
  }
});
